import { STATUS_META } from "@/lib/format";

export const StatusBadge = ({ status, className = "" }) => {
  const m = STATUS_META[status] || { label: status, color: "#fff", bg: "#2a2a2a", border: "#3f3f46" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider ${className}`}
      style={{ color: m.color, background: m.bg, border: `1px solid ${m.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.color }} />
      {m.label}
    </span>
  );
};
